(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('GroupePlanningDialogController', GroupePlanningDialogController);

    GroupePlanningDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GroupePlanning'];

    function GroupePlanningDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GroupePlanning) {
        var vm = this;

        vm.groupePlanning = entity;
        vm.colors = [
            "Bleu",
            "Vert",
            "Jaune",
            "Rouge",
            "Violet",
            "Orange",
            "Gris",
        ]
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.groupePlanning.id !== null){
                GroupePlanning.update(vm.groupePlanning, onSaveSuccess, onSaveError);
            } else {
                GroupePlanning.save(vm.groupePlanning, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            // $scope.$emit('tmgApp:groupePlanningUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();
